import ContinuousCarousel from '@/components/continuous-carousel';

const JUDGE_PHOTOS = [
  '/assets/images/hack-25/platanus-hack-8.webp',
  '/assets/images/hack-25/platanus-hack-9.webp',
  '/assets/images/hack-25/platanus-hack-10.webp',
  '/assets/images/hack-25/platanus-hack-11.webp',
  '/assets/images/hack-25/platanus-hack-12.webp',
  '/assets/images/hack-25/platanus-hack-13.webp',
  '/assets/images/hack-25/platanus-hack-1.webp',
  '/assets/images/hack-25/platanus-hack-23.webp',
] as const;

export function JudgePhotoCarousel() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 bg-gradient-to-r from-background to-transparent sm:w-16" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 bg-gradient-to-l from-background to-transparent sm:w-16" />
      <ContinuousCarousel speed={26} gap={12} pauseOnHover height="220px">
        {JUDGE_PHOTOS.map((src) => (
          <div
            key={src}
            className="relative aspect-[4/3] h-full overflow-hidden rounded-lg border-2 border-primary/40"
          >
            <img
              src={src}
              alt="Presentaciones y jurado de una edición anterior de Platanus Hack"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        ))}
      </ContinuousCarousel>
    </div>
  );
}
